import classNames from 'classnames';

import ContentfulRichText from '@tb-core/components/ui/contentful-rich-text';
import usePageContext from '@tb-core/hooks/use-page-context';

import styles from './styles.scss';

export interface BasicFooterProps {
    className?: string;
}

// @todo this is not following core component best practices, remove page context hook from this component
const BasicFooter = ({ className }: BasicFooterProps) => {
    const {
        content: {
            pageData: { layout }
        }
    } = usePageContext();
    const { footerCopy } = layout;

    return (
        <>
            {footerCopy?.json && (
                <footer className={classNames(styles.footer, className)}>
                    <ContentfulRichText node={footerCopy.json} />
                </footer>
            )}
        </>
    );
};

export default BasicFooter;
